import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Autoplay, Mousewheel, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import { imagesData } from '../media'
const FilterableGallery = () => {
    const [filter, setFilter] = useState('businessBrandings');
    const [shuffledImages, setShuffledImages] = useState([]);
    const galleryRef = useRef(null);

    useEffect(() => {
        if (filter === 'all') {
            setShuffledImages(shuffleArray(imagesData));
        }
    }, [filter]);

    const handleFilter = (newFilter) => {
        setFilter(newFilter);
    };

    const shuffleArray = (array) => {
        const result = array.slice();
        for (let i = result.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [result[i], result[j]] = [result[j], result[i]];
        }
        return result;
    };

    const filteredImages = filter === 'all' ? shuffledImages : imagesData.filter(image => filter === image.filter);

    useEffect(() => {
        if (!galleryRef.current) return;
        const lightbox = new PhotoSwipeLightbox({
            gallery: galleryRef.current,
            children: 'a',
            pswpModule: () => import('photoswipe'),
            bgOpacity: 0.9,
            padding: { top: 20, bottom: 20, left: 20, right: 20 },
        });
        lightbox.init();
        return () => lightbox.destroy();
    }, [filter, shuffledImages]);




    return (
        <div className=' py-20 specialBg   '>

            <h1 data-aos="fade-down"
                data-aos-easing="ease-in-out" className="font-bold  text-3xl md:text-5xl text-center gold-text" >

                עבודות להתרשמות</h1>
            <h2 data-aos="fade-in"
                data-aos-easing="ease-in-out" className=" font-medium my-2 text-xl md:text-3xl text-center text-mainColor ">
                חלק גדול מהעבודות שיצאו מדיגיטל פלוס
            </h2>

            <div className=" mx-auto   my-8 text-center max-w-[1200px]   py-4 rounded-2xl">
                <div data-aos="fade-in"
                    data-aos-easing="ease-in-out" className=" my-4 rounded-2xl bg-gradient-to-tr from-bgColor to-bgColor1 border-2 border-bgPath">
                    <Swiper
                        modules={[FreeMode, Pagination, Mousewheel, Autoplay, Scrollbar]}
                        autoplay={{ delay: 1000, disableOnInteraction: true }}
                        dir='rtl'
                        // loop={true}
                        freeMode={true}
                        grabCursor={true}
                        scrollbar={{ draggable: true }} // Updated to provide scrollbar configuration

                        className=" max-w-[1200px]  rounded-2xl z-0"
                        breakpoints={{
                            // when window width is >= 320px (small screen)
                            0: {
                                slidesPerView: 2.5,
                            },
                            320: {
                                slidesPerView: 2.5,
                            },
                            // when window width is >= 768px (medium screen)
                            768: {
                                slidesPerView: 4.5,
                            },
                            // when window width is >= 1024px (large screen)
                            1024: {
                                slidesPerView: 5.5,
                            },
                        }}
                    >

                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('all')} className={`${filter === 'all' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300'}`}>הכל</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('billboards')} className={`${filter === 'billboards' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>שלטי חוצות</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('businessBrandings')} className={`${filter === 'businessBrandings' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>מיתוג עסקי</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('carBrandings')} className={`${filter === 'carBrandings' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>מיתוג רכב</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('domStickers')} className={`${filter === 'domStickers' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>מדבקות לרכב</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('exhibitions')} className={`${filter === 'exhibitions' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>עיצובי תערוכות</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('graphicDesigns')} className={`${filter === 'graphicDesigns' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>עיצובים גרפיים</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('posts')} className={`${filter === 'posts' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>פוסטים</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('cards')} className={`${filter === 'cards' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>מארזי קלפים</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('stickers')} className={`${filter === 'stickers' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>מדבקות</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('boxes')} className={`${filter === 'boxes' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>אריזות</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('notes')} className={`${filter === 'notes' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>מחברות וספרים</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4'>
                            <button onClick={() => handleFilter('special')} className={`${filter === 'special' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300'}`}>מיוחדים</button>
                        </SwiperSlide>
                        <SwiperSlide className='my-4 !w-auto'>
                            <button onClick={() => handleFilter('folders')} className={`${filter === 'folders' ? 'px-4 py-1 bg-bgColor text-white hover:shadow-2xl hover:bg-bgColor hover:text-white font-bold rounded-full duration-300 whitespace-nowrap' : 'px-4 py-1 bg-mainColor text-bgColor hover:shadow-2xl hover:bg-bgColor hover:text-white  font-bold rounded-full duration-300 whitespace-nowrap'}`}>פולדרים, ניתן להזמין גם כולל עיצוב גרפי</button>
                        </SwiperSlide>

                    </Swiper>



                </div>


                <div className="flex justify-center items-center">
                    <div ref={galleryRef} className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 p-4 lg:grid-cols-4 rounded-2xl gap-4 md:gap-8">
                        {filteredImages.map((image, index) => (
                            <div data-aos="fade-down"
                                data-aos-easing="ease-in-out" key={index}>
                                <a href={image.src} data-pswp-width="1000" data-pswp-height="1000" target="_blank" rel="noreferrer">
                                    <img 
                                        onLoad={(e) => {
                                            e.target.parentElement.setAttribute('data-pswp-width', e.target.naturalWidth);
                                            e.target.parentElement.setAttribute('data-pswp-height', e.target.naturalHeight);
                                        }}
                                        className={`mix ${image.filter} shadow-4xl hover:scale-105 duration-300 w-full aspect-square object-cover rounded-xl cursor-pointer`} 
                                        src={image.src} 
                                        alt={`עבודה ${index}`} 
                                    />
                                </a>
                            </div>
                        ))}
                    </div>
                </div>



                <div className="text-center mt-4">
                </div>

            </div>

        </div >
    )
}

export default FilterableGallery